import { filter, flatMap, map, delayWhen } from 'rxjs/operators';
import { of, timer } from 'rxjs';
import { ofType, combineEpics } from 'redux-observable';
import interpolateWithComponents from '@clearscore/helpers.interpolate-with-components';
import { selectors as marketSelectors } from '@clearscore/redux.market';
import { types, actions, constants } from '@clearscore/redux.alerts';

import interpolateMessageValues from './lib/interpolate-message-values';
import callConfigMethod from './lib/call-config-method';

const isConfiguredAlert = (alertActionsConfig) => ({ type }) => alertActionsConfig[type];

const getState = (state$) => state$.value;

/**
 * @description Middleware to handle displaying generic alerts based on action configuration
 */

const alertsEpic = (alertActionsConfig = {}) => {
    const showAlertEpic = (action$, state$) => {
        const processAlert = ({ type, payload = {}, requestData = {}, requestMeta = {} }) => {
            const alertConfigParams = {
                locale: marketSelectors.getActiveLocale(getState(state$)),
                market: marketSelectors.getActiveMarket(getState(state$)),
                payload,
                requestData,
                requestMeta,
            };
            return callConfigMethod(alertActionsConfig, type, alertConfigParams);
        };

        const showAlert = ({ alertType, message, Components, title, ...alert }) => {
            const interpolatedMessage = interpolateMessageValues(message, getState(state$));
            const interpolatedTitle = title ? interpolateMessageValues(title, getState(state$)) : '';

            return of(
                actions.showAlert({
                    ...alert,
                    alertType: alertType || constants.WARNING,
                    alertContent: interpolateWithComponents(interpolatedMessage, Components),
                    ...(title ? { title: interpolateWithComponents(interpolatedTitle, Components) } : {}),
                }),
            );
        };

        return action$.pipe(
            filter(isConfiguredAlert(alertActionsConfig)),
            map(processAlert),
            filter((alert) => alert),
            flatMap(showAlert),
        );
    };

    const dismissTimeoutAlertEpic = (action$) =>
        action$.pipe(
            ofType(types.ALERTS_SHOW_ALERT),
            map(({ payload: { dismissTimeout } }) => dismissTimeout),
            filter((dismissTimeout) => !!dismissTimeout),
            delayWhen((dismissTimeout) => timer(dismissTimeout)),
            flatMap(() => of(actions.dismissAlert())),
        );

    return combineEpics(showAlertEpic, dismissTimeoutAlertEpic);
};

export default alertsEpic;
